// ===================================
// BROWSER-KOMPATIBLE SLIDER-ARTICLE-FIGURE.JS
// ===================================

// app/Scripts/Modules/slider-article-figure.js
(function() {
	'use strict'
	
	// ===================================
	// DOM-FUNKTIONEN (ersetzt '../abstract/dom.js')
	// ===================================
	
	function $(sel, ctx) {
		ctx = ctx || document
		return ctx.querySelector(sel)
	}
	
	function $$(sel, ctx) {
		ctx = ctx || document
		return Array.prototype.slice.call(ctx.querySelectorAll(sel))
	}
	
	// ===================================
	// INITIALISIERUNG
	// ===================================
	
	function initSliderArticleFigure() {
		// Prüfen ob benötigte Libraries verfügbar sind
		if (!window.Flickity) {
			console.error('Slider Article Figure: Flickity nicht verfügbar')
			return
		}
		
		// GSAP/Tween Referenz (verschiedene mögliche Namen)
		var Tween = window.Tween || 
				   (window.gsap && window.gsap.set && window.gsap) || 
				   window.TweenMax || 
				   window.TweenLite
		
		if (!Tween) {
			console.error('Slider Article Figure: GSAP/Tween nicht verfügbar')
			return
		}
		
		// ===================================
		// ORIGINAL-LOGIK (browser-kompatibel)
		// ===================================
		
		$$('.article-figure-slider').forEach(function(slider) {
			try {
				var flkty = new window.Flickity($('.flickity-flow', slider), {
					cellAlign: 'center',
					adaptiveHeight: true,
					imagesLoaded: true,
					// prevNextButtons: false,
					accessibility: true,
					// pageDots: false,
					on: {
						ready: function() {
							var positionX = -this.x - this.slides[0].target
							var progress = positionX / this.slidesWidth
							this.figCaptions = this.cells.map(function(cell) {
								return $$('figcaption', cell.element)
							})
							this.options.on.scroll.call(this, progress)
						},
						scroll: function(progress) {
							var slides = this.slides
							var cells = this.cells
							var length = slides.length
							
							cells.forEach(function(cell, i) {
								var offset = progress * (length - 1) - i
								var scaleOffset = Math.min(1, Math.max(offset, -1))
								var posnOffset = offset > 1 ? offset - 1 : offset < -1 ? offset + 1 : 0
								var scale = 1 - 0.5 * Math.abs(scaleOffset)
								var transform = 'scale(' + scale + ') translate3d(' + ((cell.size.width - 40) * posnOffset) + 'px,0,0)'
								
								Tween.set(cell.element, {
									transform: transform
								})
								
								var posnType = offset < 0 ? 'next' : 'prev'
								if (!('posnType' in cell) || cell.posnType != posnType) {
									cell.element.classList.remove('cell-prev', 'cell-next')
									cell.element.classList.add('cell-' + posnType)
									cell.posnType = posnType
								}
								
								if (this.figCaptions && this.figCaptions[i]) {
									var opacity = (1 / 2 - Math.abs(offset)) * 2
									Tween.set(this.figCaptions[i], {
										opacity: opacity
									})
								}
							}.bind(this))
						}
					}
				})
				
				/**
				 * PREVENT IOS SCROLL WHEN SWIPING
				 * also works with the window listener in app.js
				 * https://github.com/metafizzy/flickity/issues/740#issuecomment-442202965
				 */
				flkty.on('dragStart', function() {
					document.ontouchmove = function(e) {
						e.preventDefault()
					}
				})
				
				flkty.on('dragEnd', function() {
					document.ontouchmove = function() {
						return true
					}
				})
				
			} catch (error) {
				console.error('Slider Article Figure Fehler:', error)
			}
		})
		
		console.log('Slider Article Figure: Initialisiert für', $$('.article-figure-slider').length, 'Slider')
	}
	
	// ===================================
	// DOM-READY CHECK
	// ===================================
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSliderArticleFigure)
	} else {
		initSliderArticleFigure()
	}
	
})()